import { Checkbox } from 'primereact/checkbox';

const BaseCheckbox = (props)=>{
    return <Checkbox {...props}></Checkbox>
}

export default BaseCheckbox;